import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9b0f5e54"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container center"
}
const _hoisted_2 = { class: "mb--20 none-Mobile" }
const _hoisted_3 = { class: "classification__data-slot" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "xs-font-size" }, "К объявлению", -1))
const _hoisted_6 = { class: "classification__topBar" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "xs-font-size" }, "К объявлению", -1))
const _hoisted_8 = {
  key: 2,
  class: "mb--20"
}
const _hoisted_9 = { class: "classification__item-title" }
const _hoisted_10 = { class: "classification__item-title-right" }
const _hoisted_11 = { class: "classification__item-title-info" }
const _hoisted_12 = { class: "main-color" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "|", -1))
const _hoisted_14 = { class: "items-in-line gap--5" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "none-Mobile" }, "Максимальное значение:", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "only-mobile" }, "Макс. значение:", -1))
const _hoisted_17 = { class: "main-color" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "classification__table" }
const _hoisted_20 = {
  key: 1,
  class: "second-color"
}
const _hoisted_21 = { class: "classification__item-content-btn-box" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "mt--20 only-mobile" }

import { onMounted, Ref, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { HeaderType, ItemType } from '@/types/TableTypes';
import { InfoTopBar, SecondHeader } from '@/components';
import { useClassificationStore } from '@/store/modules/classification';
import { ClassifierType } from '@/types/ClassifierTypes';
import { useAppStore } from '@/store/modules/app';
import { useElementVisibility } from '@vueuse/core';
import { BaseDivider } from '@/components/UI';


export default /*#__PURE__*/_defineComponent({
  __name: 'ClassificationComponent',
  props: {
    fromProfile: { type: Boolean }
  },
  emits: ['handleClick'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const classifierTopBlock = ref<HTMLInputElement>();
const isVisible = useElementVisibility(classifierTopBlock);

const getHeaders = (weight: number): HeaderType[] => {
  return [
    {
      text: 'Влияние',
      value: 'influence',
      align: 'center',
    },
    { text: 'Вес', value: 'weight', align: 'center' },
    {
      text: 'Вес ЖК',
      value: 'complexWeight',
      backGroundColumn: '#EAFAD6',
      align: 'center',
    },
    { text: 'Подкатегории', value: 'subcategories' },
    {
      text: `${Math.round(weight * 2) / 10}`,
      value: '1',
      color: 'white',
      backGroundColor: '#0097CB',
      align: 'center',
    },
    {
      text: `${Math.round(weight * 4) / 10}`,
      value: '2',
      color: 'white',
      backGroundColor: '#009D3E',
      align: 'center',
    },
    {
      text: `${Math.round(weight * 6) / 10}`,
      value: '3',
      backGroundColor: '#EEE503',
      align: 'center',
    },
    {
      text: `${Math.round(weight * 8) / 10}`,
      value: '4',
      color: 'white',
      backGroundColor: '#E99A01',
      align: 'center',
    },
    {
      text: `${Math.round(weight * 10) / 10}`,
      value: '5',
      color: 'white',
      backGroundColor: '#C16800',
      align: 'center',
    },
  ];
};
const showClassifications = ref(true);
const loading = ref(false);
const classifier: Ref<undefined | ClassifierType> = ref(undefined);
const handleClick = () => {
  emit('handleClick');
};
const categoryWeight = (values: ItemType[]): number => {
  return +values
    .map(el => el.complexWeight.value)
    .filter(el => typeof el === 'number')
    .reduce(function (a, b) {
      return Number(a) + Number(b);
    }, 0);
};
const router = useRouter();

onMounted(async () => {
  const cardId = useRoute().query.id;

  loading.value = true;

  if (cardId) {
    try {
      const res = await useClassificationStore().searchClassifierById(+cardId);

      if (res) {
        classifier.value = res;
      } else {
        await router.push({ name: 'main' });
      }
    } finally {
      loading.value = false;
    }
  } else {
    await router.push({ name: 'main' });
  }
});

return (_ctx: any,_cache: any) => {
  const _component_base_spinner = _resolveComponent("base-spinner")!
  const _component_base_progress_bar = _resolveComponent("base-progress-bar")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_rating_number = _resolveComponent("base-rating-number")!
  const _component_base_table = _resolveComponent("base-table")!
  const _component_base_expansion_panels = _resolveComponent("base-expansion-panels")!

  return (loading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_base_spinner, {
          size: 50,
          color: "#009D3E"
        })
      ]))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass([{ fromProfile: _ctx.fromProfile }, "container cardsBlock classification"])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(InfoTopBar), { text: "В данном разделе вы можете ознакомиться с основной информацией по жилому комплексу. Сервис предоставляет информацию на основе сбора, систематизации и анализа сведений." })
        ]),
        (classifier.value)
          ? (_openBlock(), _createBlock(_unref(SecondHeader), {
              key: 0,
              ref_key: "classifierTopBlock",
              ref: classifierTopBlock,
              modelValue: showClassifications.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showClassifications).value = $event)),
              "is-sticky": _unref(useAppStore)().getWindowWidth() > 600,
              logo: classifier.value.logo,
              "offer-card-id": classifier.value?.isResidentialComplex ? undefined : classifier.value.id,
              phone: classifier.value?.phone,
              title: classifier.value?.name
            }, {
              data: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  (_unref(isVisible))
                    ? (_openBlock(), _createBlock(_component_base_progress_bar, {
                        key: 0,
                        "max-rate": classifier.value?.classifier?.maxRate,
                        rating: classifier.value?.classifier.calculationResult,
                        class: "classification__seller-first-rating"
                      }, null, 8, ["max-rate", "rating"]))
                    : _createCommentVNode("", true),
                  _createVNode(_unref(BaseDivider), { vertical: "" }),
                  _createElementVNode("span", null, "Дата заключения: " + _toDisplayString(classifier.value?.updateDate), 1)
                ])
              ]),
              btn: _withCtx(() => [
                (classifier.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      (classifier.value?.isResidentialComplex)
                        ? (_openBlock(), _createBlock(_component_base_button, {
                            key: 0,
                            href: { name: 'residentialComplex', params: { url: classifier.value?.customUrl } },
                            "all-block-width": "",
                            class: "no-wrap none-Mobile",
                            "style-type": "coloredBorder",
                            text: "На страницу ЖК"
                          }, null, 8, ["href"]))
                        : (_openBlock(), _createBlock(_component_base_button, {
                            key: 1,
                            href: { name: 'offerCard', params: { url: classifier.value?.customUrl } },
                            "all-block-width": "",
                            class: "no-wrap none-Mobile",
                            "style-type": "coloredBorder",
                            text: "К объявлению"
                          }, null, 8, ["href"])),
                      _createVNode(_component_base_button, {
                        href: { name: 'offerCard', params: { url: classifier.value?.customUrl } },
                        class: "only-mobile",
                        "style-type": "greenBorder"
                      }, {
                        text: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      }, 8, ["href"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue", "is-sticky", "logo", "offer-card-id", "phone", "title"]))
          : _createCommentVNode("", true),
        (classifier.value && !_unref(isVisible) && _unref(useAppStore)().getWindowWidth() <= 600)
          ? (_openBlock(), _createBlock(_unref(SecondHeader), {
              key: 1,
              modelValue: showClassifications.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showClassifications).value = $event)),
              logo: classifier.value.logo,
              "offer-card-id": classifier.value?.isResidentialComplex ? undefined : classifier.value.id,
              phone: classifier.value.phone,
              title: classifier.value.name
            }, {
              title: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", null, _toDisplayString(classifier.value.name), 1),
                  _createVNode(_component_base_rating_number, {
                    "max-rate": classifier.value?.classifier?.maxRate,
                    rating: classifier.value.classifier.calculationResult
                  }, null, 8, ["max-rate", "rating"])
                ])
              ]),
              btn: _withCtx(() => [
                (classifier.value)
                  ? (_openBlock(), _createBlock(_component_base_button, {
                      key: 0,
                      href: {
            name: classifier.value?.isResidentialComplex ? 'residentialComplex' : 'offerCard',
            params: { url: classifier.value?.customUrl },
          },
                      text: classifier.value?.isResidentialComplex ? 'На страницу ЖК' : 'К объявлению',
                      "all-block-width": "",
                      class: "no-wrap none-Mobile",
                      "style-type": "coloredBorder"
                    }, null, 8, ["href", "text"]))
                  : _createCommentVNode("", true),
                (classifier.value)
                  ? (_openBlock(), _createBlock(_component_base_button, {
                      key: 1,
                      href: { name: 'offerCard', params: { url: classifier.value?.customUrl } },
                      class: "only-mobile",
                      "style-type": "greenBorder"
                    }, {
                      text: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    }, 8, ["href"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue", "logo", "offer-card-id", "phone", "title"]))
          : _createCommentVNode("", true),
        (showClassifications.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(classifier.value?.classifier?.categories, (item, i) => {
                return (_openBlock(), _createBlock(_component_base_expansion_panels, {
                  key: i,
                  "is-open": true,
                  class: "classification__expansion-panels",
                  isMobileCollapse: "",
                  "without-mobile-shadow": ""
                }, {
                  title: _withCtx((titleProps) => [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", null, _toDisplayString(item.title), 1),
                      _createVNode(_unref(BaseDivider), { class: "classification__item-title-divider" }),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", null, [
                            _createTextVNode(" Индекс ЖК: "),
                            _createElementVNode("span", _hoisted_12, _toDisplayString(categoryWeight(item.values)), 1)
                          ]),
                          _hoisted_13,
                          _createElementVNode("div", _hoisted_14, [
                            _hoisted_15,
                            _hoisted_16,
                            _createElementVNode("span", _hoisted_17, _toDisplayString(item.weight), 1)
                          ])
                        ]),
                        _createElementVNode("button", {
                          class: "classification__item-title-btn",
                          onClick: ($event: any) => (titleProps.events.handleClick())
                        }, _toDisplayString(titleProps.data ? 'Свернуть' : 'Развернуть'), 9, _hoisted_18)
                      ])
                    ])
                  ]),
                  content: _withCtx((contentProps) => [
                    _createElementVNode("div", _hoisted_19, [
                      (item.values?.length)
                        ? (_openBlock(), _createBlock(_component_base_table, {
                            key: 0,
                            headers: getHeaders(item.weight),
                            items: item.values
                          }, null, 8, ["headers", "items"]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_20, "Нет данных"))
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("button", {
                        class: "classification__item-content-btn",
                        onClick: ($event: any) => (contentProps.events.handleClick())
                      }, _toDisplayString(contentProps.data ? 'Свернуть' : 'Развернуть'), 9, _hoisted_22)
                    ])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_23, [
          _createVNode(_unref(InfoTopBar), { text: "В данном разделе вы можете ознакомиться с основной информацией по жилому комплексу. Сервис предоставляет информацию на основе сбора, систематизации и анализа сведений." })
        ])
      ], 2))
}
}

})